export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9949.4bacd154.jpg";